module.exports = __webpack_public_path__ + "static/media/renfe.9de02736.png";